module.exports = __webpack_public_path__ + "static/media/6.974865a3.svg";